import { theme as twTheme } from 'styles/tailwind';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Custom twMerge configuration that understands our design system tokens
 *
 * This extends the default tailwind-merge to recognize our custom spacing,
 * colors, typography, and other design tokens defined in tailwind.config.ts
 */

// Extract tokens from the Tailwind config
const extractTokens = (theme: typeof twTheme) => {
  return {
    spacing: Object.keys(theme.spacing || {}),
    borderRadius: Object.keys(theme.borderRadius || {}),
    colors: Object.keys(theme.colors || {}),
    zIndex: Object.keys(theme.zIndex || {}),
    boxShadow: Object.keys(theme.boxShadow || {}),
    fontFamily: Object.keys(theme.fontFamily || {}),
    fontSize: Object.keys(theme.fontSize || {}),
    fontWeight: Object.keys(theme.fontWeight || {}),
    lineHeight: Object.keys(theme.lineHeight || {}),
    letterSpacing: Object.keys(theme.letterSpacing || {}),
  };
};

const tokens = extractTokens(twTheme);

export const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: tokens.spacing,
    },
    classGroups: {
      z: [
        {
          z: tokens.zIndex,
        },
      ],
      shadow: [
        {
          shadow: tokens.boxShadow,
        },
      ],
      'font-family': [
        {
          font: tokens.fontFamily,
        },
      ],
      'font-size': [
        {
          text: tokens.fontSize,
        },
      ],
      'font-weight': [
        {
          font: tokens.fontWeight,
        },
      ],
      leading: [
        {
          leading: tokens.lineHeight,
        },
      ],
      tracking: [
        {
          tracking: tokens.letterSpacing,
        },
      ],
      rounded: [{ rounded: tokens.borderRadius }],
    },
  },
});
